// @flow
import React,{Fragment} from 'react'
import {connect} from 'react-redux'
import TosContent from '../partials/TosContent'
import { Link } from 'react-router-dom'
import Footer from '../partials/Footer.jsx'
import $ from 'jquery'
class TermOfServices extends React.Component<Props>{
    constructor(props) {
		super(props)

		// bindAll(this, [
		// 	'handleCheckInterviewCode'
		// ])
	}
    componentDidMount() {
		window.scrollTo(0, 0)
        $('#public').attr('id','not-public')
    }

  componentWillUnmount(){
    $('#not-public').attr('id','public')
  }
    render(){
     
      
        return(
            <Fragment>
             <header id="headerSection" className="headContainerWhite">
                <div className="container">
                    <div className="sticky-nav header">
                    <nav className="navbar">
                        <div className="container-fluid">
                        <div className="navbar-header navbar-faq-left">
                            <Link className="navbar-brand" to={`/`}>ASTRNT</Link>
                        </div>
                        
                           
                        </div>
                    </nav>
                    </div>
                </div>
            </header>
            <TosContent/>
            <Footer/>
            </Fragment>

        )
    }
}

const mapStateToProps = (state, ownProps) => {
	return {
		
	}
}


export default connect(mapStateToProps, null)(TermOfServices)